// Fetch wrappers for the PUBLIC campaign/participant functions — no session
// cookie needed, these are reachable by anyone with the link.

const BASE = '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}/${path}`, {
    headers: options.body ? { 'Content-Type': 'application/json' } : undefined,
    ...options,
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    // no body
  }

  if (!res.ok) {
    throw new Error((data && data.error) || `Request failed (${res.status})`);
  }
  return data;
}

export const getPublicProject = (domain) =>
  request(`project-public?domain=${encodeURIComponent(domain)}`);

export const activateProject = (domain, code) =>
  request('activate', { method: 'POST', body: JSON.stringify({ domain, code }) });

export const submitCanvasMessage = (domain, sender_name, message_body) =>
  request('canvas-submit', { method: 'POST', body: JSON.stringify({ domain, sender_name, message_body }) });
